angular.module('picmonic-common').value("counts", {"users":2210000,"facts":80000,"presos":592,"preso_schools":313});